export default {
  true: 'Да',
  false: 'Нет',
  gender: {
    male: 'Мужской',
    female: 'Женский',
  },
};
